import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { PetitionReadyToSharePosts } from 'src/app/shared/api/readyToShare';
import type {
	PetitionReadyToSharePostsQuery,
	PetitionReadyToSharePostsQueryVariables,
} from 'src/app/shared/api/readyToShare';

export type Result = Extract<
	NonNullable<PetitionReadyToSharePostsQuery['petitionReadyToSharePosts']>,
	{ __typename: 'PetitionReadyToSharePosts' }
>;

export async function getPetitionReadyToSharePosts({
	slugOrId,
	fetch,
}: {
	slugOrId: string;
	fetch: UtilityContext['gql']['fetch'];
}): Promise<Result | undefined> {
	const { data } = await fetch<PetitionReadyToSharePostsQuery, PetitionReadyToSharePostsQueryVariables>({
		query: PetitionReadyToSharePosts,
		variables: { slugOrId },
		rejectOnError: false,
	});

	if (!data) return undefined;

	return data.petitionReadyToSharePosts.__typename === 'PetitionReadyToSharePosts'
		? data.petitionReadyToSharePosts
		: undefined;
}
